import {Routes} from '@angular/router';
import {authGuard} from "./core/auth/auth.guard";

export const routes: Routes = [
    {path: 'auth', loadComponent: () => import('./modules/auth/auth.component').then(m => m.AuthComponent)},
    {path: 'login', loadComponent: () => import('./modules/login/login.component').then(m => m.LoginComponent)},
    {
        path: 'recovery/:id',
        loadComponent: () => import('./modules/recovery/recovery.component').then(m => m.RecoveryComponent)
    },
    {
        path: 'cadastro',
        loadComponent: () => import('./modules/register/register.component').then(m => m.RegisterComponent)
    },
    {
        path: 'pagamento',
        loadComponent: () => import('./modules/payment/payment.component').then(m => m.PaymentComponent)
    },
    // { path: '', redirectTo: 'conta', pathMatch: 'full' },
    {
        path: '',
        loadChildren: () => import('./layout/main/main.module').then(m => m.MainModule),
        // canActivate: [authGuard]
    },
    {path: '**', redirectTo: 'login'}
];
